import React, { useState, useEffect, useRef  } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { Card } from 'primereact/card';
import { Messages } from 'primereact/messages';
import { Dialog } from 'primereact/dialog';
import { Toolbar } from 'primereact/toolbar';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { useAuth } from '../contexts/AuthContext';
import Container from 'react-bootstrap/Container';
import { Toast } from 'primereact/toast';
import { ScrollTop } from 'primereact/scrolltop';
import { OverlayPanel } from 'primereact/overlaypanel';
import { ProgressBar } from 'primereact/progressbar';
import useStatusPageScript from '../hooks/useStatusPageScript.js';
import '../config.js'
import AccessState from './AccessState';
import AccessPointPinSettingsDialog from './AccessPointPinSettingsDialog';
import AccessPointDirectionControl from './AccessPointDirectionControl';
import accessPointDirectionsApi from '../api/accessPointDirectionsApi';
import { accessPointDirectionScope, accessPointRouteType } from '../utils/accessPointDirections';
import { flagError } from '../utils/flagSystem';
import { canAccessInternalPages } from '../utils/accessControl';
import usePageAccessRedirect from '../hooks/usePageAccessRedirect';

const AccessPoints = () => {
  // Load the status page script
  useStatusPageScript();
  
  const { type: routeType, typeId, typeName } = useParams();
  const type = accessPointRouteType(routeType);
  const { accessContext, isAuthReady, isLoggedIn } = useAuth();
  const canConfigureDirection = isAuthReady && isLoggedIn && canAccessInternalPages(accessContext);
  const accessPointRequest = useRef(0);
  const [accessPoints, setAccessPoints] = useState([]);
  const [accessPointsShow, setAccessPointsShow] = useState([]);
  const [directionLoad, setDirectionLoad] = useState(null);
  const [directionReload, setDirectionReload] = useState(0);
  const directionToken = localStorage.getItem('token');
  const directionRoute = `${type}:${typeId}`;
  const navigate = useNavigate();
  const [rowSelectionModel, setRowSelectionModel] = useState();
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    relay: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    tile: { value: null, matchMode: FilterMatchMode.STARTS_WITH},
    gate: { value: null, matchMode: FilterMatchMode.STARTS_WITH},
    client : { value: null, matchMode: FilterMatchMode.STARTS_WITH},
  });
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [loading, setLoading] = useState(true);
  const msgs = useRef(null);
  const [createVisible, setCreateVisible] = useState(false);
  const [newAPRelay, setNewAPRelay] = useState('');
  const [newAPGate, setNewAPGate] = useState('');
  const [newAPLocation, setNewAPLocation] = useState(-1);
  const [stLocations, setLocations] = useState([]);
  const [newAPClient, setNewAPClient] = useState(-1);
  const [stClients, setClients] = useState([]);
  const [stCustomers, setCustomers] = useState([]);
  const toast = useRef(null);
  const toastBC = useRef(null);
  const [createLoading, setCreateLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [copyVisible, setCopyVisible] = useState(false);
  const [innovatiseLink, setInnovatiseLink] = useState('');
  const [innovatiseLinkId, setInnovatiseLinkId] = useState(null);
  const [newLink, setNewLink] = useState('');
  var [updatedAP, setUpdatedAP] = useState(0);
  const [newCLientName, setNewClientName] = useState('');
  const [islocation, setIsLocation] = useState(false);
  const [memberNumber, setMemberNumber] = useState('');
  const [testMemberVisible, setTestMemberVisible] = useState(false);
  const [pinSettingsVisible, setPinSettingsVisible] = useState(false);
  const { accessIssue, clearAccessIssue, handleAccessError } = usePageAccessRedirect({
    deniedTitle: 'Access Points Access Denied',
    deniedMessage: 'You do not have permission to view or manage access points for this record.',
  });

  const [moveVisible, setMoveVisible] = useState(false);
  const [moveSaving, setMoveSaving] = useState(false);
  const [moveTarget, setMoveTarget] = useState(null);
  const [moveLocationId, setMoveLocationId] = useState(-1);
  const [moveClientId, setMoveClientId] = useState(-1);
  const [moveClients, setMoveClients] = useState([]);
  const [moveClientsLoading, setMoveClientsLoading] = useState(false);
  const moveMsgs = useRef(null);

  const [createMoveLocationVisible, setCreateMoveLocationVisible] = useState(false);
  const [createMoveLocationSaving, setCreateMoveLocationSaving] = useState(false);
  const [createMoveLocationName, setCreateMoveLocationName] = useState('');
  const [createMoveLocationExtra, setCreateMoveLocationExtra] = useState('');
  const createMoveLocationMsgs = useRef(null);

  const [createMoveClientVisible, setCreateMoveClientVisible] = useState(false);
  const [createMoveClientSaving, setCreateMoveClientSaving] = useState(false);
  const [createMoveClientName, setCreateMoveClientName] = useState('');
  const [createMoveClientLms, setCreateMoveClientLms] = useState('');
  const [clientLmsConversion, setClientLmsConversion] = useState(null);
  const [clientLmsOptions, setClientLmsOptions] = useState([]);
  const createMoveClientMsgs = useRef(null);

  const op = useRef(null);
  const link = useRef(null);
  const nlink = useRef(null);
  const dt = useRef(null);

  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    sortField: null,
    sortOrder: null,
    filters: {
        relay: { value: '', matchMode: 'contains' },
        tile: { value: '', matchMode: 'contains' },
        gate: { value: '', matchMode: 'contains' },
        'client.name': { value: '', matchMode: 'contains' },
        'location.name': { value: '', matchMode: 'contains' },
    }
});

const onSort = (event) => {
  console.log(event);
  setlazyState(event);
};

  const authHeader = () => {
    const token = localStorage.getItem('token');
    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  };

  const getKeybyValue = (object, value) => {
    if (!object || typeof object !== 'object') return undefined;
    return Object.keys(object).find((key) => object[key] === value);
  };

  useEffect(() => {
    let active = true;
    if (!canConfigureDirection) { setDirectionLoad(null); return; }
    const source = { points: accessPoints, context: accessContext, token: directionToken, route: directionRoute };
    setDirectionLoad({ ...source, groups: {} });
    const scopes = new Map();
    accessPoints.forEach(point => {
      const scope = accessPointDirectionScope(point, { type, typeId });
      if (scope) scopes.set(`${scope.customerId}:${scope.locationId}`, scope);
    });
    scopes.forEach(async (scope, key) => {
      let result;
      try {
        const records = await accessPointDirectionsApi.list(scope.customerId, scope.locationId);
        result = { records };
      } catch (error) {
        if (!active || directionToken !== localStorage.getItem('token')) return;
        handleAccessError(error);
        result = { error: flagError(error, 'Could not load access-point directions. Please retry.') };
      }
      if (!active || directionToken !== localStorage.getItem('token')) return;
      setDirectionLoad(previous => ({ ...source, groups: { ...previous.groups, [key]: result } }));
    });
    return () => { active = false; };
    // Scope changes invalidate all pending direction reads.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessPoints, canConfigureDirection, accessContext, directionToken, directionRoute, directionReload]);

  const directionState = point => {
    const scope = accessPointDirectionScope(point, { type, typeId });
    if (!scope) return undefined;
    if (!directionLoad || directionLoad.points !== accessPoints || directionLoad.context !== accessContext ||
        directionLoad.token !== directionToken || directionLoad.route !== directionRoute) return { loading: true };
    const group = directionLoad.groups[`${scope.customerId}:${scope.locationId}`];
    if (!group) return { loading: true };
    if (group.error) return { error: group.error };
    const record = group.records.find(item => item.accessPointId === scope.accessPointId);
    return record ? { record } : { error: 'Direction data is unavailable for this access point. Reload before configuring it.' };
  };

  useEffect(() => {
    const fetchAccessPoints = async () => {
      await getAccessPoints();
    };

    fetchAccessPoints();

    let _filters = JSON.parse(localStorage.getItem('accesspointsFilters'));
    if (_filters) {
      setFilters(_filters);
      setGlobalFilterValue(_filters.global.value);
    }
    return () => { accessPointRequest.current += 1; };
  }, [type, typeId, typeName, lazyState]);

  useEffect(() => {

    // updateAccessPoint();
  }, [updatedAP]);

  const getAccessPoints = async () => {
    const requestId = ++accessPointRequest.current;
    const requestToken = localStorage.getItem('token');
    const isCurrent = () => requestId === accessPointRequest.current && requestToken === localStorage.getItem('token');
    setIsLocation(type === 'Location');
    try {
      clearAccessIssue();
      setLoading(true);
      setAccessPoints([]);
      setAccessPointsShow([]);
      const token = localStorage.getItem('token');
      let header = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      console.log("get access points " + type + " " + typeId);
      const response = await axios.get(global.config.url + `/accesspoints/By${type}/${typeId}`, header);
        if (!isCurrent()) return;
        setAccessPoints(response.data);
        setLoading(false);
        const ap = [...response.data];
        // setAccessPointsShow(ap.sort((a, b) => (a.tile < b.tile) ? 1 : -1));
        setAccessPointsShow(ap);
        if (!ap.length) { setClients([]); setLocations([]); return; }
        const endpoint = type.toLowerCase() === 'client' ? `/clients/ByLocation/${ap[0].locationId}` : `/clients/By${type}/${typeId}`;
        const responseClients = await axios.get(global.config.url + endpoint, header);
        if (!isCurrent()) return;
        setClients(responseClients.data);
        if(type !== 'Customer'){
          const responseLoc = await axios.get(global.config.url + `/locations/ByCustomer/${ap[0].location.customerId}`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
            if (!isCurrent()) return;
            setLocations(responseLoc.data);
        }
    } catch (error) {
      if (!isCurrent()) return;
      setLoading(false);
      if (handleAccessError(error)) return;
      if (msgs.current) msgs.current.show({ severity: 'error', summary: '', detail: 'Could not load access points or their location context. Refresh and try again.' });
    }
  };

  const loadLocationsForCustomer = async (customerId) => {
    if (!customerId) return;

    try {
      const responseLoc = await axios.get(
        global.config.url + `/locations/ByCustomer/${customerId}`,
        authHeader()
      );
      setLocations(Array.isArray(responseLoc.data) ? responseLoc.data : []);
    } catch (error) {
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to view locations for this record.' })) {
        return;
      }

      if (moveMsgs.current) {
        moveMsgs.current.show({ severity: 'error', summary: '', detail: 'Failed to load locations. Please try again.' });
      }
    }
  };

  const loadClientsForLocation = async (locationId) => {
    if (!locationId || locationId === -1) {
      setMoveClients([]);
      return;
    }

    try {
      setMoveClientsLoading(true);
      const response = await axios.get(
        global.config.url + `/clients/ByLocation/${locationId}`,
        authHeader()
      );
      setMoveClients(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to view clients for this location.' })) {
        return;
      }

      setMoveClients([]);
      if (moveMsgs.current) {
        moveMsgs.current.show({ severity: 'error', summary: '', detail: 'Failed to load clients for the selected location.' });
      }
    } finally {
      setMoveClientsLoading(false);
    }
  };

  const openMoveDialog = async (rowData) => {
    setMoveTarget(rowData);
    setMoveLocationId(rowData && rowData.locationId ? rowData.locationId : -1);
    setMoveClientId(rowData && rowData.clientId ? rowData.clientId : -1);
    setMoveClients([]);
    if (moveMsgs.current) moveMsgs.current.clear();

    const customerId =
      rowData && rowData.location && rowData.location.customerId
        ? rowData.location.customerId
        : type === 'Customer'
          ? Number(typeId)
          : null;

    if (!Array.isArray(stLocations) || stLocations.length === 0) {
      await loadLocationsForCustomer(customerId);
    }

    if (rowData && rowData.locationId) {
      await loadClientsForLocation(rowData.locationId);
    }

    setMoveVisible(true);
  };

  const closeMoveDialog = () => {
    setMoveVisible(false);
    setMoveSaving(false);
    setMoveTarget(null);
    setMoveLocationId(-1);
    setMoveClientId(-1);
    setMoveClients([]);
    if (moveMsgs.current) moveMsgs.current.clear();
  };

  const selectedMoveClient = Array.isArray(moveClients)
    ? moveClients.find((c) => c && c.id === moveClientId)
    : null;

  const isMoveValid =
    moveTarget &&
    moveLocationId !== -1 &&
    moveClientId !== -1 &&
    selectedMoveClient &&
    Number(selectedMoveClient.locationId) === Number(moveLocationId);

  const saveMove = async () => {
    if (!isMoveValid) return;

    try {
      setMoveSaving(true);
      if (moveMsgs.current) moveMsgs.current.clear();

      const payload = {
        locationId: moveLocationId,
        clientId: moveClientId,
      };

      const response = await axios.put(
        global.config.url + `/accesspoints/${moveTarget.id}/move`,
        payload,
        authHeader()
      );

      if (response.status === 200 || response.status === 204) {
        msgs.current.show({ severity: 'success', summary: '', detail: 'Access point moved successfully.' });
        closeMoveDialog();
        getAccessPoints();
        return;
      }

      if (moveMsgs.current) {
        moveMsgs.current.show({ severity: 'error', summary: '', detail: 'Unexpected response from server while moving access point.' });
      }
    } catch (error) {
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to move this access point.' })) {
        return;
      }

      const detail =
        (error && error.response && error.response.data) ||
        (error && error.message) ||
        'Failed to move access point.';

      if (moveMsgs.current) {
        moveMsgs.current.show({ severity: 'error', summary: '', detail });
      }
    } finally {
      setMoveSaving(false);
    }
  };

  const onMoveLocationChange = async (nextLocationId) => {
    setMoveLocationId(nextLocationId);
    setMoveClientId(-1);
    await loadClientsForLocation(nextLocationId);
  };

  const openCreateLocationFromMove = () => {
    setCreateMoveLocationName('');
    setCreateMoveLocationExtra('');
    if (createMoveLocationMsgs.current) createMoveLocationMsgs.current.clear();
    setCreateMoveLocationVisible(true);
  };

  const createLocationFromMove = async () => {
    const name = String(createMoveLocationName || '').trim();
    if (!name) {
      if (createMoveLocationMsgs.current) {
        createMoveLocationMsgs.current.show({ severity: 'error', summary: '', detail: 'Please enter a location name.' });
      }
      return;
    }

    const customerId =
      moveTarget && moveTarget.location && moveTarget.location.customerId
        ? moveTarget.location.customerId
        : type === 'Customer'
          ? Number(typeId)
          : null;

    if (!customerId) {
      if (createMoveLocationMsgs.current) {
        createMoveLocationMsgs.current.show({ severity: 'error', summary: '', detail: 'Unable to resolve customer for new location.' });
      }
      return;
    }

    try {
      setCreateMoveLocationSaving(true);
      if (createMoveLocationMsgs.current) createMoveLocationMsgs.current.clear();

      const newLocation = {
        name,
        extra: String(createMoveLocationExtra || ''),
        id: 0,
        lms: 0,
        customerId,
        status: false,
      };

      const response = await axios.post(
        global.config.url + '/locations',
        newLocation,
        authHeader()
      );

      if (response.status === 201 && response.data && response.data.id) {
        msgs.current.show({ severity: 'success', summary: '', detail: 'Location created successfully.' });
        await loadLocationsForCustomer(customerId);
        setCreateMoveLocationVisible(false);

        const createdId = response.data.id;
        await onMoveLocationChange(createdId);
        return;
      }

      if (createMoveLocationMsgs.current) {
        createMoveLocationMsgs.current.show({ severity: 'error', summary: '', detail: 'Failed to create location.' });
      }
    } catch (error) {
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to create locations for this customer.' })) {
        return;
      }

      const detail =
        (error && error.response && error.response.data) ||
        (error && error.message) ||
        'Failed to create location.';

      if (createMoveLocationMsgs.current) {
        createMoveLocationMsgs.current.show({ severity: 'error', summary: '', detail });
      }
    } finally {
      setCreateMoveLocationSaving(false);
    }
  };

  const openCreateClientFromMove = async () => {
    if (!moveLocationId || moveLocationId === -1) {
      if (moveMsgs.current) {
        moveMsgs.current.show({ severity: 'warn', summary: '', detail: 'Select a location before creating a client.' });
      }
      return;
    }

    setCreateMoveClientName('');
    setCreateMoveClientLms('');
    if (createMoveClientMsgs.current) createMoveClientMsgs.current.clear();

    try {
      if (!clientLmsConversion) {
        const response = await axios.get(global.config.url + '/clients/lmsConversion', authHeader());
        setClientLmsConversion(response.data);
        setClientLmsOptions(Object.values(response.data || {}));
      }
    } catch (_) {
      // If LMS conversion fails we can still show dialog, but creation may fail.
    }

    setCreateMoveClientVisible(true);
  };

  const createClientFromMove = async () => {
    const name = String(createMoveClientName || '').trim();
    const lmsValue = String(createMoveClientLms || '').trim();
    if (!name) {
      if (createMoveClientMsgs.current) {
        createMoveClientMsgs.current.show({ severity: 'error', summary: '', detail: 'Please enter a client name.' });
      }
      return;
    }

    if (!moveLocationId || moveLocationId === -1) {
      if (createMoveClientMsgs.current) {
        createMoveClientMsgs.current.show({ severity: 'error', summary: '', detail: 'Please select a location first.' });
      }
      return;
    }

    if (!lmsValue) {
      if (createMoveClientMsgs.current) {
        createMoveClientMsgs.current.show({ severity: 'error', summary: '', detail: 'Please select an LMS for the new client.' });
      }
      return;
    }

    const lmsKey = getKeybyValue(clientLmsConversion, lmsValue);
    if (lmsKey === undefined) {
      if (createMoveClientMsgs.current) {
        createMoveClientMsgs.current.show({ severity: 'error', summary: '', detail: 'Invalid LMS selection.' });
      }
      return;
    }

    try {
      setCreateMoveClientSaving(true);
      if (createMoveClientMsgs.current) createMoveClientMsgs.current.clear();

      const newClient = {
        id: 0,
        name,
        locationId: moveLocationId,
        status: false,
        lms: lmsKey,
      };

      const response = await axios.post(global.config.url + '/clients', newClient, authHeader());

      if (response.status === 201 && response.data && response.data.id) {
        msgs.current.show({ severity: 'success', summary: '', detail: 'Client created successfully.' });
        setCreateMoveClientVisible(false);
        await loadClientsForLocation(moveLocationId);
        setMoveClientId(response.data.id);
        return;
      }

      if (createMoveClientMsgs.current) {
        createMoveClientMsgs.current.show({ severity: 'error', summary: '', detail: 'Failed to create client.' });
      }
    } catch (error) {
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to create clients for this location.' })) {
        return;
      }

      const detail =
        (error && error.response && error.response.data) ||
        (error && error.message) ||
        'Failed to create client.';

      if (createMoveClientMsgs.current) {
        createMoveClientMsgs.current.show({ severity: 'error', summary: '', detail });
      }
    } finally {
      setCreateMoveClientSaving(false);
    }
  };

  const getLocations = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(global.config.url + `/locations/ByCustomer/${typeId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      setLocations(response.data);
      console.log(stLocations);
    } catch (error) {
      console.error('Error fetching locations:', error);
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to view locations for this record.' })) {
        return;
      }
    }
  };

  const getClients = async (value, ty) => {
    try {
      const token = localStorage.getItem('token');
      if(value === undefined){
        value = typeId;
      }
      const endpoint = ty.toLowerCase() === 'client' ? `/clients/${value}` : `/clients/By${ty}/${value}`;
      const response = await axios.get(global.config.url + endpoint, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      const responseClients = [];
      responseClients.push(response.data);
      setClients(responseClients);
    } catch (error) {
      console.error('Error fetching client:', error);
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to view clients for this record.' })) {
        return;
      }
    }
  };

  const getEvents = () => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.gate === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select an access point to view logs.'});
    }
    else{
      navigate(`/events/accesspoint/${rowSelectionModel.gate} at ${typeName}/${rowSelectionModel.id}`);
    }
  };
  const getLogs = () => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.gate === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select an access point to view logs.'});
    }
    else{
      navigate(`/logs/accesspoint/${rowSelectionModel.gate} at ${typeName}/${rowSelectionModel.id}`);
    }
  };

  const testAP = async (member) => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.gate === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select an access point to test.'});
    }
    else{
      const token = localStorage.getItem('token');
      let url = global.config.url + `/accesspoints/testmember/${rowSelectionModel.id}/${memberNumber}`;
      if(!member || memberNumber === '' || memberNumber === undefined || memberNumber === null){
        url = global.config.url + `/accesspoints/test/${rowSelectionModel.id}`;
      }
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      console.log(response);
      if(response.status === 200){
        if(response.data === true){
            msgs.current.show({severity: 'success', summary: '', detail: 'Access allowed by lms.'});
        }
        else{
            msgs.current.show({severity: 'warn', summary: '', detail: 'Access denied by lms.'});
        }
      }
      else{
        msgs.current.show({severity: 'error', summary: '', detail: 'Error testing access point.'});
      }
    }
  };

  const addKeyPad = async () => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.gate === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select an access point to add KeyPad.'});
    }
    else{
      const token = localStorage.getItem('token');
      let url = global.config.url + `/accesspoints/addkeypad/${rowSelectionModel.id}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      console.log(response);
      if(response.status === 200){
            msgs.current.show({severity: 'success', summary: '', detail: 'Keypad created.'});
      }
      else if(response.status === 204)
      {
        msgs.current.show({severity: 'error', summary: '', detail: 'Please add the hub and relay config to this access point first.'});
      }
      else{
        msgs.current.show({severity: 'error', summary: '', detail: 'Error creating keypad.'});
      }
    }
  };


  const openScannerReader = async () => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.gate === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select an access point to open the reader configuration.'});
    }
    else{
      const token = localStorage.getItem('token');
      const response = await axios.get(global.config.url + `/accesspoints/reader/${rowSelectionModel.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      console.log(response);
      let url = response.data;
      if(response.status === 200){
        window.open(url, '_blank');
      }
      else{
        msgs.current.show({severity: 'error', summary: '', detail: 'Error opening the reader configuration.'});
      }
      // navigate(`/logs/accesspoint/${rowSelectionModel.gate} at ${typeName}/${rowSelectionModel.id}`);
    }
  };

  const getExtraInfo =() => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.gate === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select an access point to view extra info.'});
    }
    else{
      navigate(`/extra-info/${rowSelectionModel.id}`);
    }
  }

  const getHubRelays = () => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.gate === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select an access point to view hub relays.'});
    }
    else{
      navigate(`/hubrelay/AccessPoint/${rowSelectionModel.id}`);
    }
  }

  const exportCSV = (selectionOnly) => {
    dt.current.exportCSV({ selectionOnly });
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters['global'].value = value;

    localStorage.setItem('accesspointsFilters', JSON.stringify(_filters));

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const setAccessPointsChanges = (accessPoint) => {
    console.log(accessPoint["client.name"]);
    console.log(stClients)
    let client = stClients.find(x => x.name === accessPoint["client.name"]);
    accessPoint.clientId = client.id;
    accessPoint.client = client;
    console.log(accessPoint);
    setAccessPoints(accessPoint);
  }

  const onRowEditComplete = async (e) => {
    let { newData, index } = e;
    let clientName = newCLientName;
    if(clientName === undefined || clientName === null || clientName === ""){
      clientName = newData.client.name;
    }
    let client = stClients.find(x => x.name === clientName);
    newData.clientId = client.id;
    newData.client = client;
    let aps = [...accessPoints];
    aps[index] = newData;
    setAccessPoints(aps);
    confirm(null, newData);
  };

  const updateAccessPoint = async (newdata) => {
    try {
      // if(newdata === undefined){ return; }
      clear(false)
      const token = localStorage.getItem('token');
      var axiosConfig = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.put(global.config.url + `/accesspoints/${newdata.id}`, newdata, axiosConfig);
      if(response.status === 200){
        msgs.current.show({severity: 'success', summary: '', detail: 'Access point updated successfully.'});
      }
      else{
        msgs.current.show({severity: 'error', summary: '', detail: 'Error updating access point.'});
      }
    } catch (error) {
      console.error('Error updating access point:', error);
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to update this access point.' })) {
        return;
      }
    }
  }

  const textEditor = (options) => {
    return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
  };

  const setNewClient = (options, value) => {
    options.editorCallback(value);
    setNewClientName(value);
  }

  const setDropdownClients = (options) => {
    if(type === 'Customer') return;
    return <Dropdown
      value={stClients.find(x => x.name === options.value).name}
      options={stClients.map(x => x.name)}
      onChange={(e) => setNewClient(options, e.value)}
      placeholder="Select a Client"
    />;
  }

  const setDropdownLocations = async (options) => {

    if(type === 'Customer') return;
    // return <Dropdown
    //   value={stLocations.find(x => x.name === options.value).name}
    //   options={stLocations.map(x => x.name)}
    //   onChange={(e) => options.editorCallback(e.value)}
    //   placeholder="Select a Location"
    // />;


  }

  const sendQRCodes = async () => {
    let token = localStorage.getItem('token');
    let axiosConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    };
    try {
      const response = await axios.get(global.config.url + `/locations/qr/${typeId}`, axiosConfig);
      if(response.status === 200){
        if(response.data === true){
          msgs.current.show({severity: 'success', summary: '', detail: `QR codes sent successfully.`});
        }
        else{
          msgs.current.show({severity: 'error', summary: '', detail: `Error sending QR codes, check if the links have been submitted and try again.`});
        }
      }
      else{
        msgs.current.show({severity: 'error', summary: '', detail: `Error sending QR codes, please try again.`});
      }
    } catch (error) {
      console.error('Error fetching customers:', error);
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to send QR codes for this record.' })) {
        return;
      }
    }
  }

  const openBarcodeReader = async () => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.gate === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select an access point to open the barcode reader.'});
    }
    else{
      navigate(`/barcodereaders/${rowSelectionModel.id}`);
    }
  };

  const openPinSettings = () => {
    if(rowSelectionModel === undefined || rowSelectionModel.id === 0 || rowSelectionModel.gate === null){
      msgs.current.show({severity: 'error', summary: '', detail: 'Please select an access point to configure PIN settings.'});
      return;
    }
    setPinSettingsVisible(true);
  };

  const startContent = (
    <React.Fragment>
      <div>
        <Button onClick={() => getLogs()} label="Get Access Logs" icon="pi pi-file" className="p-button ml-3 mb-3" tooltip="Get access logs for this access point" tooltipOptions={{position:"bottom"}}/>
        <Button onClick={() => getExtraInfo()} label="Access Point Settings" icon="pi pi-cog" className="p-button-info ml-3 mb-3" tooltip="Configure settings for this access point" tooltipOptions={{position:"bottom"}}/>
        <Button onClick={openPinSettings} label="Access PIN Settings" icon="pi pi-key" className="p-button-secondary ml-3 mb-3" tooltip="Configure PIN settings for this access point" tooltipOptions={{position:"bottom"}}/>
        <Button onClick={() => getHubRelays()} label='Hub and Relays' icon="pi pi-sitemap" className="p-button-success ml-3 mb-3" tooltip="Get hub and relays for this access point" tooltipOptions={{position:"bottom"}}/>
        <Button onClick={() => openScannerReader()} label='Add Scanner Reader' icon="pi pi-qrcode" className="p-button-secondary ml-3 mb-3" tooltip="Open scanner reader for this access point" tooltipOptions={{position:"bottom"}}/>
        <Button onClick={(e) => testAP(false)} label='Quick Test' icon="pi pi-send" className="p-button-help is-light ml-3 mb-3" tooltip="Test this access point" tooltipOptions={{position:"bottom"}}/>
      </div>
        {/* <Button onClick={() => getEvents()} label="Get Events" icon="pi pi-file" className="p-button-warning mx-5" tooltip="Get events for this access point" tooltipOptions={{position:"bottom"}}/> */}
      <div className=''>
        <Button onClick={(e) => setTestMemberVisible(true)} label='Test Member' icon="pi pi-send" className="p-button-info is-light ml-3 mb-3" tooltip="Test this access point" tooltipOptions={{position:"bottom"}}/>
        <Button onClick={() => openBarcodeReader()} label='Barcode Reader' icon="pi pi-code" className="p-button-warning ml-3 mb-3" tooltip="Open barcode reader for this access point" tooltipOptions={{position:"bottom"}}/>
        <Button onClick={() => addKeyPad()} label='Add Keypad' icon="pi pi-calculator" className="p-button-danger ml-3 mb-3" tooltip="Open barcode reader for this access point" tooltipOptions={{position:"bottom"}}/>
      </div>
    </React.Fragment>
);


const copyContent = (
  <React.Fragment>

    <DataTable value={accessPointsShow} dataKey="id" showGridlines filters={filters} globalFilterFields={['tile', 'gate', 'location.name']} >
      <Column field="tile" header="Tile"  />
      <Column field="gate" header="Gate Name" />
      <Column field="location.name" header="Location"  />
    </DataTable>
  </React.Fragment>
);

const testMemberAP = (
  <React.Fragment>

    <InputText type="text" id="memberNumber" value={memberNumber} placeholder="Member number..." onChange={(e) => setMemberNumber(e.target.value)} required/>
    <Button onClick={() => testAP(true)} label='Test Member' icon="pi pi-send" className="p-button-help is-light mx-5" tooltip="Test this access point" tooltipOptions={{position:"bottom"}}/>
  </React.Fragment>
);

const filterContent = (
    <span className="p-input-icon-left mb-3 ml-3">
      <i className="pi pi-search" />
      <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Filter by relay, tile, gate or client name" tooltip="Start typing a relay, tile, gate or client name" tooltipOptions={{position: "bottom"}}  />
    </span>
);

const clearFilter = () => {
  let _filters = { ...filters };
  _filters['global'].value = null;
  setFilters(_filters);
  setGlobalFilterValue('');
  localStorage.removeItem('accesspointsFilters');
};

const footerContent = (
  <div>
      <Button label="No" icon="pi pi-times" onClick={() => cancelNewAP(false)} className="p-button-text" />
      <Button label="Yes" icon="pi pi-check" onClick={() => confirm(true)} autoFocus />
  </div>
);

const createAP = () => {
  if(type === 'Customer'){
    getLocations();
  }
  if(type === 'Location'){
    setNewAPLocation(typeId);
    getClients(typeId, 'Location');
  }
  console.log(stClients);
  setCreateVisible(true);
}

const cancelNewAP = () => {
  setNewAPGate('');
  setNewAPRelay('');
  setNewAPLocation(-1);
  setCreateVisible(false);
}

const clear = () => {
  toastBC.current.clear();
};

const confirm = (create, newdata) => {
  if(create === null){
    toastBC.current.show({
      severity: 'info',
      sticky: true,
      className: 'border-none',
      content: (
          <div className="flex flex-column align-items-center" style={{ flex: '1' }}>
              <div className="text-center">
                  <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
                  <div className="font-bold text-xl my-3">Are you sure?</div>
              </div>
              <div className="flex align-items-center">
                  <Button onClick={(e) => updateAccessPoint(newdata)} type="button" label="Confirm" className="p-button-success w-6rem" />
                  <Button onClick={(e) => clear(false)} type="button" label="Cancel" className="p-button-warning w-6rem mx-4" />
              </div>
          </div>
      )
    });
  }
  else{
    if(create){
      if(newAPRelay=== undefined || newAPRelay === ''){
        toast.current.show({severity: 'error', summary: '', detail: 'Please enter a relay for the new access point.'});
        return;
      }
      if(newAPGate=== undefined || newAPGate === ''){
        toast.current.show({severity: 'error', summary: '', detail: 'Please select gate name for the new access point.'});
        return;
      }
      toastBC.current.show({
        severity: 'info',
        sticky: true,
        className: 'border-none',
        content: (
            <div className="flex flex-column align-items-center" style={{ flex: '1' }}>
                <div className="text-center">
                    <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
                    <div className="font-bold text-xl my-3">Are you sure?</div>
                </div>
                <div className="flex align-items-center">
                    <Button onClick={(e) => createAccessPoint()} type="button" label="Confirm" className="p-button-success w-6rem" />
                    <Button onClick={(e) => clear(false)} type="button" label="Cancel" className="p-button-warning w-6rem mx-4" />
                </div>
            </div>
        )
      });
    }
    else{
      toastBC.current.show({
        severity: 'info',
        sticky: true,
        className: 'border-none',
        content: (
            <div className="flex flex-column align-items-center" style={{ flex: '1' }}>
                <div className="text-center">
                    <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
                    <div className="font-bold text-xl my-3">Are you sure?</div>
                </div>
                <div className="flex align-items-center">
                    <Button onClick={(e) => deleteAccessPoint()} type="button" label="Confirm" className="p-button-success w-6rem" />
                    <Button onClick={(e) => clear(false)} type="button" label="Cancel" className="p-button-warning w-6rem mx-4" />
                </div>
            </div>
        )
      });
    }
  }

};

const createAccessPoint = async () => {
  setCreateLoading(true);
  clear(true);
  const token = localStorage.getItem('token');
  var newAP = {
    "id": 0,
    "relay": newAPRelay,
    "tile": "string",
    "locationId": 0,
    "location": {      
      "id": 0,
      "name": "stromg",
      "customerId": 0,
      "lms": 0,
      "extra": "string",
      "status": false
    },
    "gate": newAPGate,
    "clientId":  parseInt(typeId),
    "client": {
      "id": 0,
      "name": "string",
      "locationId": 0,
      "status": false,
      "lms": 0
    }
  }
  if(type === 'Customer'){
    newAP.locationId = newAPLocation;
    newAP.clientId = newAPClient;
    newAP.client.id = newAPClient;
    newAP.client.locationId = newAPLocation;
  }
  else if(type === 'Location'){
    newAP.locationId = parseInt(typeId);
    newAP.clientId = newAPClient;
    newAP.client.id = newAPClient;
    newAP.client.locationId = parseInt(typeId);
  }

  let axiosConfig = {
    headers: {
        // 'Content-Type': 'application/json;charset=UTF-8',
        // "Access-Control-Allow-Origin": "*",
        Authorization: `Bearer ${token}`,
    }
  };
  try {
    const response = await axios.post(global.config.url + '/accesspoints', newAP, axiosConfig);
    console.log(response);
    if(response.status === 201){
      msgs.current.show({severity: 'success', summary: '', detail: `Access point successfully created.`});
      getAccessPoints();
      setCreateVisible(false);
      setNewAPGate('');
      setNewAPRelay('');
    }
    else{
      toast.current.show({severity: 'error', summary: '', detail: 'Error creating the access point, please try again.'});
    }

  } catch (error) {
    console.error('Error creating access point:', error);
    if (handleAccessError(error, { deniedMessage: 'You do not have permission to create access points for this record.' })) {
      setCreateLoading(false);
      return;
    }
    else if(error.response && error.response.status === 400){
      toast.current.show({severity: 'error', summary: '', detail: 'Error creating the access point, please try again.'});
    }
    else if(error.response && error.response.status === 500){
      toast.current.show({severity: 'error', summary: '', detail: 'Error creating the access point, please try again.'});
    }
    else if(error.response && error.response.status === 409){
      toast.current.show({severity: 'error', summary: '', detail: error.response.data});
    }
  }
  setCreateLoading(false);
};

const deleteAccessPoint = async () => {
  setDeleteLoading(true);
  clear(true);
  const token = localStorage.getItem('token');
  if(rowSelectionModel === undefined || rowSelectionModel === 0){
    msgs.current.show({severity: 'error', summary: '', detail: 'Please select an access point to delete.'});
    return;
  }
  try {
    let axiosConfig = {
      headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${token}`,
      }
    };
    const response = await axios.delete(global.config.url + `/accesspoints/${rowSelectionModel}`, axiosConfig);
    console.log(response);
    if(response.status === 204){
      msgs.current.show({severity: 'success', summary: '', detail: `Access point deleted successfully.`});
      getAccessPoints();
      setCreateVisible(false);
    }
    else{
      toast.current.show({severity: 'error', summary: '', detail: 'Error deleting the access point, please try again.'});
    }

  } catch (error) {
    console.error('Error fetching customers:', error);
    if (handleAccessError(error, { deniedMessage: 'You do not have permission to delete this access point.' })) {
      setDeleteLoading(false);
      return;
    }
    else if(error.response && error.response.status === 400){
      toast.current.show({severity: 'error', summary: '', detail: 'Error deleting the access point, please try again.'});
    }
    else if(error.response && error.response.status === 500){
      toast.current.show({severity: 'error', summary: '', detail: 'Error deleting the access point, please try again.'});
    }
  }
  setDeleteLoading(false);
};

  const setNewLocation = (value) => {
    setNewAPLocation(value);
    console.log(value);
    // getClients(value, 'Location');
  }

  const optionsSelected = (e, rowData) =>{
    op.current.toggle(e);
    setRowSelectionModel(rowData);
  }

  const optionsTemplate = (rowData) => {
    return <Button link icon="pi pi-ellipsis-v" onClick={(e) => optionsSelected(e, rowData)} />;
  };

  const moveTemplate = (rowData) => {
    return (
      <Button
        link
        icon="pi pi-arrows-h"
        onClick={() => openMoveDialog(rowData)}
        tooltip="Move access point"
        tooltipOptions={{ position: 'bottom' }}
      />
    );
  };

  const copyToClipboard = (e) => {
    console.log(e);
    var textField = document.createElement('textarea')
    textField.innerText = e;
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
  }

  const downloadQRPost = async()=> {
  const token = localStorage.getItem('token');
  if(innovatiseLink === ''){
    msgs.current.show({severity: 'error', summary: '', detail: 'Please select an access point to download QR code.'});
    return;
  }
    let axiosConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: 'blob' // Important
  };
  console.log(innovatiseLink);
  try {
    axios.post(global.config.url + `/accesspoints/generateqrfromlink`, {link: innovatiseLink}, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    })
    .then(response => {
      console.log(response.data);
      const byteCharacters = atob(response.data.qrCode);
      const byteNumbers = Array.from(byteCharacters).map(ch => ch.charCodeAt(0));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'image/png' });
      const imageUrl = window.URL.createObjectURL(blob);
      
      // Create an image element to load the QR code
      const img = new Image();
      img.onload = function() {
        // Create canvas
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        // Set canvas dimensions (QR code + space for text)
        const padding = 20;
        const textHeight = 40;
        canvas.width = img.width + (padding * 2);
        canvas.height = img.height + textHeight + (padding * 3);
        
        // Fill white background
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        
        // Draw QR code centered horizontally
        ctx.drawImage(img, padding, padding);
        
        // Add text below QR code
        ctx.fillStyle = 'black';
        ctx.font = '16px Arial';
        ctx.textAlign = 'center';
        
        // You can customize this text - could be response.data.name or any other text
        const text = response.data.name || 'Smart Tile Access Point';
        ctx.fillText(text, canvas.width / 2, img.height + padding * 2 + 20);
        
        // Convert canvas to blob and download
        canvas.toBlob(function(canvasBlob) {
          const url = window.URL.createObjectURL(canvasBlob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', response.data.name + '.png');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          // Clean up URLs
          window.URL.revokeObjectURL(imageUrl);
          window.URL.revokeObjectURL(url);
          
          msgs.current.show({severity: 'success', summary: '', detail: 'QR code with text downloaded successfully.'});
        }, 'image/png');
      };
      
      img.src = imageUrl;
    })
    .catch(error => {
      console.error('QR code generation failed:', error);
      msgs.current.show({severity: 'error', summary: '', detail: 'Error downloading QR code, please try again.'});
    });
  }
  catch (error) {
    console.error('Error downloading QR code:', error);
    msgs.current.show({severity: 'error', summary: '', detail: 'Error downloading QR code, please try again.'});
  }
}

  const updateInnovatiseLink = async () => {
    if (!rowSelectionModel || !rowSelectionModel.id) {
      msgs.current.show({ severity: 'error', summary: '', detail: 'Please select an access point to update the link.' });
      return;
    }
    if (!innovatiseLinkId) {
      msgs.current.show({ severity: 'error', summary: '', detail: 'No existing link found to update.' });
      return;
    }
    if (!innovatiseLink || innovatiseLink.trim() === '') {
      msgs.current.show({ severity: 'error', summary: '', detail: 'Please enter a valid link.' });
      return;
    }

    try {
      const token = localStorage.getItem('token');
      let axiosConfig = {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      };

      const payload = {
        id: innovatiseLinkId,
        accessPointId: rowSelectionModel.id,
        link: innovatiseLink,
      };

      const response = await axios.put(global.config.url + '/accesspoints/link', payload, axiosConfig);
      if (response.status === 200 || response.status === 204) {
        msgs.current.show({ severity: 'success', summary: '', detail: 'Link updated successfully.' });
      } else {
        msgs.current.show({ severity: 'error', summary: '', detail: 'Error updating the link, please try again.' });
      }
    } catch (error) {
      console.error('Error updating link:', error);
      if (handleAccessError(error, { deniedMessage: 'You do not have permission to update this access point.' })) {
        return;
      } else {
        msgs.current.show({ severity: 'error', summary: '', detail: 'Error updating the link, please try again.' });
      }
    }
  };

  if (accessIssue) {
    return <AccessState {...accessIssue} />;
  }

  const linksPanel = (
    <React.Fragment>
      <div className="p-fluid p-formgrid p-grid">
        <div className="p-field p-col-12 p-md-12">
          <span className="p-float-label mt-3">
            <InputText
              id="innovatiseLink"
              value={innovatiseLink}
              onChange={(e) => setInnovatiseLink(e.target.value)}
              placeholder="Enter Innovatise link"
              style={{ minWidth: '22rem' }}
            />
            <label htmlFor="innovatiseLink">{(rowSelectionModel && rowSelectionModel.gate) ? rowSelectionModel.gate : 'Innovatise Link'}</label>
          </span>
          <Button className="p-button-primary mt-3" label="Update" icon="pi pi-save" onClick={updateInnovatiseLink} />
        </div>

        <Container className="flex align-content-center flex-wrap">
          <p id='qrlink' className='flex mt-3'>
            <b>QR Link: </b> {innovatiseLink}?t=qr
          </p>
          <Button className="p-button-success flex" link icon="pi pi-copy" onClick={() => copyToClipboard(innovatiseLink + "?t=qr")} />
          <Button className="p-button-primary flex ml-3" link icon="pi pi-download" onClick={() => downloadQRPost()} />
        </Container>

        <Container className="flex align-content-center flex-wrap">
          <p id='nfclink' className='flex mt-3'>
            <b>NFC Link: </b> {innovatiseLink}?t=nfc
          </p>
          <Button className="p-button-success" link icon="pi pi-copy" onClick={() => copyToClipboard(innovatiseLink + "?t=nfc")} />
        </Container>
      </div>
    </React.Fragment>
  );

  const createLink = async () => {
    if (!rowSelectionModel || !rowSelectionModel.id) {
      msgs.current.show({ severity: 'error', summary: '', detail: 'Please select an access point to create a link.' });
      return;
    }
    let token = localStorage.getItem('token');
    let axiosConfig = {
      headers: {
          Authorization: `Bearer ${token}`,
      }
    };
    const response = await axios.post(global.config.url + '/accesspoints/link', {id:0, accessPointId: rowSelectionModel.id, link: newLink}, axiosConfig);
    console.log(response);
    if(response.status === 201){
      setNewLink('');
      msgs.current.show({severity: 'success', summary: '', detail: `Link created successfully.`});
    }
     else 
    {
      msgs.current.show({severity: 'error', summary: '', detail: 'Error creating the link, please try again.'});
    }
  }

  const createLinkPanel = (
    <React.Fragment>
      <div className="p-fluid p-formgrid p-grid">
        <div className="p-field p-col-12 p-md-12">
          <InputText id="newLink" value={newLink} onChange={(e) => setNewLink(e.target.value)} placeholder="Enter link" />
          
          <Button className="p-button-success mt-5" label="Create" onClick={createLink} />
        </div> 
      </div>
    </React.Fragment>
  );


  const getLinks = async (e, rowData) => {
    console.log(rowData);
    setRowSelectionModel(rowData);
    //get innovatise links from api
    let token = localStorage.getItem('token');
    let axiosConfig = {
      headers: {
          Authorization: `Bearer ${token}`,
      }
    };
    const response = await axios.get(global.config.url + `/accesspoints/link/${rowData.id}`, axiosConfig);
    console.log(response);
    if(response.status === 200){
      if(response.data.length === 0){
        setInnovatiseLink('');
        setInnovatiseLinkId(null);
        nlink.current.toggle(e);
        return;
      }
      setInnovatiseLinkId(response.data[0].id);
      setInnovatiseLink(response.data[0].link);
      link.current.toggle(e);
    }
    else{
      toast.current.show({severity: 'error', summary: '', detail: 'Error fetching links, please try again.'});
    }
  }


  const linksTemplate = (rowData) => {
    return <Button link icon="pi pi-link" onClick={(e) => getLinks(e, rowData)} />;
  };

  const progressbar = (        
    <div className="card mt-3">
        <ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar>
    </div>);

    const goBack = () => {
      localStorage.removeItem('accesspointsFilters');
      navigate(-1);
    }

  return (
      <Container className ="justify-content-md-center mt-5">
        <div className="flex justify-content-center mt-3">
          <Container className="flex align-content-center flex-wrap">
            
            <Button link icon="pi pi-arrow-left" onClick={() => goBack()} className='flex mb-3'/> 
            <h4 className='flex mt-2 mb-3 ml-3'>Access points for {type.toLocaleLowerCase()} '{typeName}'</h4> 
            <div>
            {filterContent}
            <Button icon="pi pi-times" className="p-button-text mb-3" onClick={() => clearFilter()} tooltip="Clear filter" tooltipOptions={{position: "bottom"}}/>
            <Button icon="pi pi-refresh" className="p-button-text mb-3" onClick={() => getAccessPoints()} disabled={loading} tooltip="Refresh access points" tooltipOptions={{position: "bottom"}}/>
            
            <Button icon="pi pi-copy" className='p-button-secondary mr-3 ml-2 mb-3' onClick={(e) => setCopyVisible(true)} disabled={loading} rounded tooltip="Show access points in copy format" tooltipOptions={{position: "bottom"}}/>
            <Button icon="pi pi-plus" className="p-button-success mb-3" rounded loading={createLoading} disabled={loading} onClick={() => createAP()} tooltip="Create new access point" tooltipOptions={{position: "bottom"}} />
            <Button icon="pi pi-trash" className="p-button-danger mx-3 mb-3" rounded loading={deleteLoading} disabled={loading} onClick={() => confirm(false)} tooltip="Delete selected access point" tooltipOptions={{position: "bottom"}} />
            <Button type="button" icon="pi pi-file-export" className='mb-3' rounded disabled={loading} onClick={() => exportCSV(false)} tooltip="Download as csv" tooltipOptions={{position: "bottom"}} />
            <Button icon="pi pi-qrcode" className='p-button-help is-light mx-3 mb-3' rounded disabled={!islocation || loading}  onClick={() => sendQRCodes()} tooltip="Send QR codes for all access points in this location" tooltipOptions={{position: "bottom"}} />
            </div>

          </Container>
          </div>
        <Messages ref={msgs} />
        <Toast ref={toastBC} position="top-center" />
          <AccessPointPinSettingsDialog
            visible={pinSettingsVisible}
            accessPoint={rowSelectionModel}
            onHide={() => setPinSettingsVisible(false)}
          />
        {loading && progressbar}

        <div className='justify-content-md-center mt-3'>

          <DataTable value={accessPoints} selectionMode={'single'} selection={rowSelectionModel} onSelectionChange={(e) => setRowSelectionModel(e.value)} 
          dataKey="id" tableStyle={{ minWidth: '5rem' }}
          filters={filters} ref={dt} globalFilterFields={['relay', 'tile', 'gate', 'client.name', 'location.name']} 
          emptyMessage={loading ? "Loading access points..." :"No access points found."} editMode='row' onRowEditComplete={onRowEditComplete}
          scrollable scrollHeight="80vh">
              <Column field="options" header="" body={optionsTemplate}> </Column>
              <Column field="move" header="" body={moveTemplate}></Column>
              <Column field="gate" header="Gate" editor={(options) => textEditor(options)}></Column>
              <Column field="relay" header="Relay" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }} 
                editor={(options) => textEditor(options)} sortable></Column>
              <Column field="tile" header="Tile" sortable></Column>
              {canConfigureDirection && <Column header="Entry/Exit" body={point =>
                <AccessPointDirectionControl accessPoint={point} routeContext={{ type, typeId }} onAccessError={handleAccessError}
                  listState={directionState(point)} onRetry={() => setDirectionReload(value => value + 1)} />} />}
              <Column field="client.name" header="Client Name" editor={(options) => setDropdownClients(options)} sortable></Column>
              {/* <Column field="location.name" header="Location Name" editor={(options) => setDropdownLocations(options)} ></Column> */}
              <Column field="location.name" header="Location Name" sortable></Column>
              <Column field="options" header="" body={linksTemplate}></Column>
              <Column rowEditor headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>

          </DataTable>
          <OverlayPanel ref={op}>
            {startContent}
          </OverlayPanel>
          <OverlayPanel ref={link}>
            {linksPanel}
          </OverlayPanel>
          <OverlayPanel ref={nlink}>
            {createLinkPanel}
          </OverlayPanel>
        </div>
        <div className="card flex justify-content-center">
          <Dialog header="Create Access Point" className='justify-content-center' visible={createVisible} onHide={() => cancelNewAP()} 
            style={{ width: 'auto' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} footer={footerContent}>
            <Toast ref={toast} />
            <Container className="flex align-content-center flex-wrap">
              <span className="flex p-float-label my-4">

                <InputText
                    id="relay"
                    name="relay"
                    value={newAPRelay}
                    onChange={(e) => setNewAPRelay(e.target.value)}
                />
                <label htmlFor="input_relay">Relay</label>
              </span>
              <span className="flex p-float-label my-4 ml-3 mr-3">
                <InputText
                    id="gate"
                    name="gate"
                    value={newAPGate}
                    onChange={(e) => setNewAPGate(e.target.value)}
                />
                <label htmlFor="input_gate">Gate</label>
              </span>
              {type === 'Customer' && createVisible && stLocations.length > 0 &&
                  <span className="flex p-float-label my-4 mr-3">
                    <Dropdown 
                      inputId = "dd-location"
                      value={newAPLocation}
                      options={stLocations.map((location) => ({id: location.id, name: location.name}))}
                      onChange={(e) => setNewLocation(e.value)} 
                      optionValue="id"
                      optionLabel="name"
                      placeholder='Select a Location'
                      className="w-full md:w-14rem"
                    />  
                    <label htmlFor="dd-location">Select a Location</label>
                  </span>}
                {(type === 'Customer' || type === 'Location') && createVisible && stClients.length > 0 && newAPLocation !== -1 &&
                  <span className="flex p-float-label my-4">
                    <Dropdown 
                      inputId = "dd-client"
                      value={newAPClient}
                      // options={stClients.map((client) => ({id: client.id, name: client.name}))}
                      options={new Array(stClients.find((client) => client.locationId === newAPLocation))}
                      onChange={(e) => setNewAPClient(e.value)} 
                      optionValue="id"
                      optionLabel="name"
                      placeholder='Select a client'
                      className="w-full md:w-14rem"
                    />  
                    <label htmlFor="dd-client">Select a Client</label>
                  </span>}
            </Container>
          </Dialog>
        </div>

        <div className="card flex justify-content-center">
          <Dialog
            header="Move Access Point"
            className='justify-content-center'
            visible={moveVisible}
            onHide={() => closeMoveDialog()}
            style={{ width: 'auto' }}
            breakpoints={{ '960px': '75vw', '641px': '100vw' }}
            footer={
              <div className='flex justify-content-center mb-2'>
                <Button
                  label="Cancel"
                  icon="pi pi-times"
                  className="p-button-warning"
                  onClick={() => closeMoveDialog()}
                  disabled={moveSaving}
                />
                <Button
                  label="Save"
                  icon="pi pi-check"
                  className="p-button-success ml-3"
                  onClick={() => saveMove()}
                  loading={moveSaving}
                  disabled={!isMoveValid || moveClientsLoading || moveSaving}
                />
              </div>
            }
          >
            <Messages ref={moveMsgs} />

            {moveTarget && (
              <div className='mb-3'>
                <p className='mb-1'><b>Tile:</b> {moveTarget.tile}</p>
                <p className='mb-1'><b>Gate:</b> {moveTarget.gate}</p>
                <p className='mb-1'><b>Current Location:</b> {moveTarget.location ? moveTarget.location.name : ''}</p>
                <p className='mb-1'><b>Current Client:</b> {moveTarget.client ? moveTarget.client.name : ''}</p>
              </div>
            )}

            <Container className="flex align-content-center flex-wrap">
              <span className="flex p-float-label my-3 mr-3">
                <Dropdown
                  inputId="move-location"
                  value={moveLocationId}
                  options={(stLocations || []).map((location) => ({ id: location.id, name: location.name }))}
                  onChange={(e) => onMoveLocationChange(e.value)}
                  optionValue="id"
                  optionLabel="name"
                  placeholder='Select a Location'
                  className="w-full md:w-14rem"
                />
                <label htmlFor="move-location">Location</label>
              </span>

              <span className="flex p-float-label my-3">
                <Dropdown
                  inputId="move-client"
                  value={moveClientId}
                  options={(moveClients || []).map((client) => ({ id: client.id, name: client.name, locationId: client.locationId }))}
                  onChange={(e) => setMoveClientId(e.value)}
                  optionValue="id"
                  optionLabel="name"
                  placeholder={moveLocationId === -1 ? 'Select a location first' : (moveClientsLoading ? 'Loading clients...' : 'Select a Client')}
                  disabled={moveLocationId === -1 || moveClientsLoading}
                  className="w-full md:w-14rem"
                />
                <label htmlFor="move-client">Client</label>
              </span>
            </Container>

            <div className='mt-3'>
              <Button
                label="Create Location"
                icon="pi pi-plus"
                className="p-button-secondary"
                onClick={() => openCreateLocationFromMove()}
                disabled={moveSaving}
              />
              <Button
                label="Create Client"
                icon="pi pi-plus"
                className="p-button-secondary ml-3"
                onClick={() => openCreateClientFromMove()}
                disabled={moveSaving || moveLocationId === -1}
              />
            </div>
          </Dialog>
        </div>

        <div className="card flex justify-content-center">
          <Dialog
            header="Create Location"
            className='justify-content-center'
            visible={createMoveLocationVisible}
            onHide={() => setCreateMoveLocationVisible(false)}
            style={{ width: 'auto' }}
            breakpoints={{ '960px': '75vw', '641px': '100vw' }}
            footer={
              <div className='flex justify-content-center mb-2'>
                <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={() => setCreateMoveLocationVisible(false)} disabled={createMoveLocationSaving} />
                <Button label="Create" icon="pi pi-check" className="p-button-success ml-3" onClick={() => createLocationFromMove()} loading={createMoveLocationSaving} />
              </div>
            }
          >
            <Messages ref={createMoveLocationMsgs} />
            <Container className="flex align-content-center flex-wrap">
              <span className="flex p-float-label my-4">
                <InputText id="create-move-location-name" value={createMoveLocationName} onChange={(e) => setCreateMoveLocationName(e.target.value)} />
                <label htmlFor="create-move-location-name">Name</label>
              </span>
              <span className="flex p-float-label my-4 ml-3">
                <InputText id="create-move-location-extra" value={createMoveLocationExtra} onChange={(e) => setCreateMoveLocationExtra(e.target.value)} />
                <label htmlFor="create-move-location-extra">Extra</label>
              </span>
            </Container>
          </Dialog>
        </div>

        <div className="card flex justify-content-center">
          <Dialog
            header="Create Client"
            className='justify-content-center'
            visible={createMoveClientVisible}
            onHide={() => setCreateMoveClientVisible(false)}
            style={{ width: 'auto' }}
            breakpoints={{ '960px': '75vw', '641px': '100vw' }}
            footer={
              <div className='flex justify-content-center mb-2'>
                <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={() => setCreateMoveClientVisible(false)} disabled={createMoveClientSaving} />
                <Button label="Create" icon="pi pi-check" className="p-button-success ml-3" onClick={() => createClientFromMove()} loading={createMoveClientSaving} />
              </div>
            }
          >
            <Messages ref={createMoveClientMsgs} />
            <Container className="flex align-content-center flex-wrap">
              <span className="flex p-float-label my-4 mr-3">
                <InputText id="create-move-client-name" value={createMoveClientName} onChange={(e) => setCreateMoveClientName(e.target.value)} />
                <label htmlFor="create-move-client-name">Name</label>
              </span>
              <span className="flex p-float-label my-4">
                <Dropdown
                  inputId="create-move-client-lms"
                  value={createMoveClientLms}
                  options={clientLmsOptions}
                  onChange={(e) => setCreateMoveClientLms(e.value)}
                  placeholder="Select LMS"
                  className="w-full md:w-14rem"
                />
                <label htmlFor="create-move-client-lms">LMS</label>
              </span>
            </Container>
          </Dialog>
        </div>
        <div className="card flex justify-content-center">
          <Dialog header={filterContent} className='justify-content-center' visible={copyVisible} onHide={() => setCopyVisible(false)}>
          {copyContent}
          </Dialog>
        </div>
        <div className="card flex justify-content-center">
          <Dialog className='justify-content-center' visible={testMemberVisible} onHide={() => setTestMemberVisible(false)}>
          {testMemberAP}
          </Dialog>
        </div>
        <ScrollTop />
      </Container>
    
  );
};

export default AccessPoints;
